var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-between gutter-md" }, [
    _c(
      "div",
      { staticClass: "col-12 col-lg-6" },
      [
        _c(
          "select-option",
          {
            attrs: {
              title: _vm.$t("small_business"),
              active: _vm.isSmallBusiness === true
            },
            on: {
              click: function($event) {
                _vm.handleSelectIsSmallBusiness(true)
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "heroicon-home heroicon heroicons-lg",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "100",
                  height: "100",
                  viewBox: "0 0 100 100"
                }
              },
              [
                _c("path", {
                  staticClass: "heroicon-home-wall heroicon-component-fill",
                  attrs: {
                    d:
                      "M8 50L50 8l42 42v48H8V50zm10 7v22h12V57H18zm52 0v22h12V57H70zM50 38a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
                  }
                }),
                _c("polygon", {
                  staticClass:
                    "heroicon-home-roof heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    points:
                      "7 7 44.5 7 50 1.5 55 7 93 7 93 44 99 50 96 53 50 7 4 53 1 50 7 44"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-home-frames heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M84 79h2v4H66v-4h2V55h16v24zm-52 0h2v4H14v-4h2V55h16v24zm8-24h20v36H40V55zm10-16a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm2-12v1h4.71A7.01 7.01 0 0 0 52 23.29V27zm-8.71 1H48v-4.71A7.01 7.01 0 0 0 43.29 28zM48 36.71V32h-4.71A7.01 7.01 0 0 0 48 36.71zM56.71 32H52v4.71A7.01 7.01 0 0 0 56.71 32zM18 57v22h12V57H18zm52 0v22h12V57H70z"
                  }
                }),
                _c("rect", {
                  staticClass:
                    "heroicon-home-door heroicon-component-accent heroicon-component-fill",
                  attrs: { width: "16", height: "34", x: "42", y: "57" }
                }),
                _c("path", {
                  staticClass: "heroicon-home-windows heroicon-component-fill",
                  attrs: {
                    d:
                      "M52 27v-3.71A7.01 7.01 0 0 1 56.71 28H52v-1zm-8.71 1A7.01 7.01 0 0 1 48 23.29V28h-4.71zM48 36.71A7.01 7.01 0 0 1 43.29 32H48v4.71zM56.71 32A7.01 7.01 0 0 1 52 36.71V32h4.71zM18 57h12v22H18V57zm52 0h12v22H70V57z"
                  }
                }),
                _c("polygon", {
                  staticClass: "heroicon-home-parging heroicon-component-fill",
                  attrs: { points: "93 90 7 90 7 99 93 99" }
                }),
                _c("path", {
                  staticClass: "heroicon-shadows",
                  attrs: {
                    d:
                      "M7 50L50 7l43 43v6L50 13 7 56v-6zm7 33h20v2H14v-2zm52 0h20v2H66v-2z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-outline",
                  attrs: {
                    "fill-rule": "nonzero",
                    d:
                      "M94 98h6v2H0v-2h6V52l-.59.59L4 54l-1.41-1.41L1.4 51.4 0 50l1.41-1.41L6 44V6h38l4.59-4.59L50 0l1.41 1.41L56 6h38v38l4.59 4.59L100 50l-1.41 1.41-1.18 1.18L96 54l-1.41-1.41L94 52v46zM8 90h32V55h20v35h32V50l-4-4H12l-4 4v40zm6-46l-1 1h74l-1-1H14zm71-1L51.41 9.41 50 8l-1.41 1.41L15 43h70zm-35-3a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm9-10a9 9 0 1 0-18 0 9 9 0 0 0 18 0zm-1 0a8.02 8.02 0 0 1-10 7.75 8.01 8.01 0 0 1 4-15.5A8.01 8.01 0 0 1 58 30zm-10-1h-4.93a7.06 7.06 0 0 0 0 2H49v5.93a7.06 7.06 0 0 0 2 0V31h5.93a7.06 7.06 0 0 0 0-2H51v-5.93a7.06 7.06 0 0 0-2 0V29h-1zm4-2v1h4.71A7.01 7.01 0 0 0 52 23.29V27zm-8.71 1H48v-4.71A7.01 7.01 0 0 0 43.29 28zM48 36.71V32h-4.71A7.01 7.01 0 0 0 48 36.71zM56.71 32H52v4.71A7.01 7.01 0 0 0 56.71 32zM16 56v-1h16v24h2v4H14v-4h2V56zm15 0H17v23h1V57h12v22h1V56zm-2 23V69H19v10h10zM19 68h10V58H19v10zm14 12H15v2h18v-2zm35-24v-1h16v24h2v4H66v-4h2V56zm1 0v23h1V57h12v22h1V56H69zm2 23h10V69H71v10zm10-11V58H71v10h10zM67 80v2h18v-2H67zm-4 11v3h3v4h26v-7H63zM8 98h26v-4h3v-3H8v7zm28 0h28v-2H36v2zm23-8V56H41v34h1V57h16v33h1zm-16 0h14V58H43v32zm2.5-14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM49 60v1h-3v10h-1V60h4zm6 0v1h-3v10h-1V60h4zm0 18v1h-9v8h-1v-9h10zm6 16v-2H39v2h22zM58 8l3 3h7V9h1v2h4v1H62l7 7h7v-2h1v2h7v1H70l7 7h7v-2h1v2h2v1h-9l14 14V32h-8v-1h4v-2h1v2h3v-7h-7v-1h3v-2h1v2h3v-7H77v-1h3v-2h1v2h11v-3h-9v-1h1V9h1v2h7V8H58zM8 8v3h3V9h1v2h8v1H8v3h7v-2h1v2h14v1H8v3h11v-2h1v2h4v1H8v3h7v-2h1v3H8v7h7v-2h1v3H8v10l14-14H10v-1h9v-2h1v2h3l15-15h-6v-1h3V9h1v2h3l3-3H8zM4 51.17L48.59 6.6 50 5.17l1.41 1.42L96 51.17 97.17 50 50 2.83 2.83 50 4 51.17z"
                  }
                })
              ]
            )
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 col-lg-6" },
      [
        _c(
          "select-option",
          {
            attrs: {
              title: _vm.$t("no_small_business"),
              active: _vm.isSmallBusiness === false
            },
            on: {
              click: function($event) {
                _vm.handleSelectIsSmallBusiness(false)
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "heroicon-shop heroicon heroicons-lg",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "100",
                  height: "100",
                  viewBox: "0 0 100 100"
                }
              },
              [
                _c("path", {
                  staticClass: "heroicon-shop-wall heroicon-component-fill",
                  attrs: {
                    d:
                      "M11 7h76v93H11V7zm9 67v18h18V74H20zm40 0v18h18V74H60zm8-55v17h6V19h-6zm-22 0v17h6V19h-6zm-22 0v17h6V19h-6zm20 55v20h10V74H44z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-shop-windows heroicon-component-fill",
                  attrs: {
                    d:
                      "M44 74h10v20H44V74zm-24 0h18v18H20V74zm40 0h18v18H60V74zm8-55h6v17h-6V19zm-22 0h6v17h-6V19zm-22 0h6v17h-6V19z"
                  }
                }),
                _c("rect", {
                  staticClass:
                    "heroicon-shop-cover-fill heroicon-component-fill",
                  attrs: { width: "76", height: "18", x: "11", y: "49" }
                }),
                _c("polygon", {
                  staticClass:
                    "heroicon-shop-cover-stripes heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    points:
                      "12 50 11 50 11 66 17 66 17 52 21 52 21 66 27 66 27 52 31 52 31 66 37 66 37 52 41 52 41 66 47 66 47 52 51 52 51 66 57 66 57 52 61 52 61 66 67 66 67 52 71 52 71 66 77 66 77 52 81 52 81 66 87 66 87 50 86 50 86 49 12 49"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-shop-frames heroicon-component-accent heroicon-component-fill",
                  attrs: {
                    d:
                      "M33 36h2v4H19v-4h2V16h12v20zm22 0h2v4H41v-4h2V16h12v20zm22 0h2v4H63v-4h2V16h12v20zM24 19v17h6V19h-6zm22 0v17h6V19h-6zm22 0v17h6V19h-6zM17 71h24v24H17V71zm3 3v18h18V74H20zm37-3h24v24H57V71zm3 3v18h18V74H60z"
                  }
                }),
                _c("path", {
                  staticClass:
                    "heroicon-shop-door heroicon-component-accent heroicon-component-fill",
                  attrs: { d: "M41 71h16v29H41V71zm3 3v20h10V74H44z" }
                }),
                _c("rect", {
                  staticClass:
                    "heroicon-shop-roof heroicon-component-accent heroicon-component-fill",
                  attrs: { width: "82", height: "8", x: "8" }
                }),
                _c("path", {
                  staticClass: "heroicon-shadows",
                  attrs: {
                    d:
                      "M12 67h74v6H12v-6zm0-59h74v2H12V8zm7 32h16v2H19v-2zm22 0h16v2H41v-2zm22 0h16v2H63v-2z"
                  }
                }),
                _c("path", {
                  staticClass: "heroicon-outline",
                  attrs: {
                    "fill-rule": "nonzero",
                    d:
                      "M10 0h80v8h-2v90h12v2H0v-2h10V8H8V0h2zm76 8H12v40h74V8zM40 72H18v22h22V72zm40 22V72H58v22h22zM65 36V16h12v20h2v4H63v-4h2zm4-9h5v-8h-6v8h1zm5 1h-6v8h6v-8zm-7 8V18h8v18h1V17H66v19h1zm-3 1v2h14v-2H64zM21 17v-1h12v20h2v4H19v-4h2V17zm3 10h6v-8h-6v8zm0 1v8h6v-8h-6zm-1-9v-1h8v18h1V17H22v19h1V19zm11 18H20v2h14v-2zm8-1h1V16h12v20h2v4H41v-4h1zm4-9h6v-8h-6v8zm6 9v-8h-6v8h6zm-7-17v-1h8v18h1V17H44v19h1V19zm11 18H42v2h14v-2zM19 73h20v20H19V73zm19 1H20v18h18V74zm21-1h20v20H59V73zm1 1v18h18V74H60zM88 2H10v2h78V2zM10 6h78V5H10v1zm76 92V67h-5v31h5zm-6 0v-3H58v3h22zm-24 0V88h-1v7H43V73h12v9h1V72H42v26h14zm-16 0v-3H18v3h22zm-23 0V67h-5v31h5zm-5-48v1h74v-1H12zm70 2v8h4v-8h-4zm0 9v4h4v-4h-4zm-1 4v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm-5 5v-4h-4v4h4zm0-5v-8h-4v8h4zm24 7H18v4h22v-4zm2 4h14v-4H42v4zm38-4H58v4h22v-4zM54 83v4h2v-4h-2zm0 5h-1v-2h-9v8h10v-6zm-10-3h9v-3h1v-8H44v11z"
                  }
                })
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }